import { configureStore } from '@reduxjs/toolkit'
import { createHashHistory } from 'history'
import { createRouterMiddleware } from '@lagunovsky/redux-react-router'

import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { ReactPlugin, withAITracking } from '@microsoft/applicationinsights-react-js';

import {
  environment,
  partnerKey,
  cdpVersion,
  commonsVersion,
  isDevelopmentEnv
} from '@alias-environment';

import {
  api,
  createRootReducer,
  appInsightsInstrumentationKey
} from '../../internal'

export const storeHistory = createHashHistory();
// application insights setup
const reactPlugin = new ReactPlugin();

export const appInsights = new ApplicationInsights({
  config: {
    instrumentationKey: appInsightsInstrumentationKey,
    extensions: [reactPlugin],
    extensionConfig: {
      [reactPlugin.identifier]: { history: storeHistory }
    }
  }
});
appInsights.loadAppInsights();

// add common items to the 
const telemetryFeedbackInitializer = (envelope: any) => {
  envelope.data.environment = environment;
  envelope.data.partner = partnerKey;
  envelope.data.portalVersion = cdpVersion;
  envelope.data.commonsVersion = commonsVersion;
};
appInsights.addTelemetryInitializer(telemetryFeedbackInitializer);

export const configStore = () => configureStore({
  reducer: createRootReducer(storeHistory),
  devTools: isDevelopmentEnv ? true : false,
  middleware: (getDefaultMiddleware: any) => {
    return getDefaultMiddleware({ 
        // it works better for our use-cases to save the full class instances to redux,
        // so we're purposely turning off some of these default store options.
        serializableCheck: false,
        immutableCheck: false,
      }).concat(createRouterMiddleware(window.history))
  },
});

export const wrapWithInsights = (withAITracking.bind(null, reactPlugin) as any);